
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import {Barrier} from "@/modules/barriers/interfaces/barrier.interface";
  import {IBook} from "@/interfaces/book.interface";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import {ITrailer} from "@/modules/barriers/interfaces/trailer.interface";
  import {httpResource} from "@/resources/http.resource";
  import SimpleAppTable from "@/shared/AppTable/components/SimpleAppTable.vue";
  import {IApp} from "@/interfaces/app.interface";
  import {isMobile} from "mobile-device-detect";
  import {ICarStore} from "@/modules/Car/interfaces/car-store.interface";
  import {IAppState} from "@/interfaces/app-state.interface";
  import AppCorpsFilter from "@/components/FormControls/AppCorpsFilter.vue";

  @Component({
    components: {
      AppCorpsFilter,
      SimpleAppTable,
      AppDialog,
    },
  })
  export default class TrailerPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'barriers', dialogName: 'trailerPopup' };
    gate: Barrier.Entity = null;
    enterMode = false;
    trailerList: ITrailer.IEntity[] = [];
    tableProps = [];
    dateFormat = IApp.DateFormats;
    activeTrailer: ITrailer.IEntity = null;
    isMobile = isMobile;
    dataReady = false;
    corpId = null;
    defaultCorpName = '';
    displayTrailerBtns = false;


    get storeState(): IAppState { return this.$store.state; }
    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }
    get carPopupDisplay() { return this.storeState.car.displayPopup; }
    get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
    get corps(): IBook.CorpBookItem[] { return this.storeState.book.books[IBook.BookName.Corps]; }
    get carTypeTrailerId() {
      let trailerType = this.storeState.book.books[IBook.BookName.carTypes].find(item => item.id === 10103);
      return trailerType ? trailerType.id : null;
    }
    // get displayTrailerBtns() {
    //   let corp = this.corps.find(item => item.id === this.corpId);
    //   return corp ? corp.trailerRequestFlag : false;
    // }

    async created() {
      this.gate = this.payloadPopup.gate;
      this.enterMode = this.gate.gateType === Barrier.GateType.Enter;
      this.tableProps = ITrailer.TableTrailersColumns;
      this.corpId = this.gate.corpId;
      this.defaultCorpName = this.gate.corpName;
      this.displayTrailerBtns = this.gate.trailerRequestFlag;

      await this.getTrailers();
    }

    setCorpName(corp: IBook.CorpBookItem) {
      this.defaultCorpName = !!corp ? corp.name : '';
      this.displayTrailerBtns = !!corp ? corp.trailerRequestFlag : false;
    }

    async openCreateTrailer() {
      let createTrailerProps = [ { prop: 'headCarId', value: this.gate.carId } ];
      if (this.enterMode) {
        createTrailerProps.push({ prop: 'corpId', value: this.corpId });
      }

      let payload: ICarStore.IPopupPayload = {
        carId: null,
        createMode: true,
        createTrailer: true,
        createTrailerProps,
        carNumber: this.gate.carNumber,
        presetFields: [
          { prop: 'carTypeId', value: this.carTypeTrailerId, },
          { prop: 'comment', value: `Завез прицеп ${this.gate.carNumber}`, },
          { prop: 'corpId', value: this.corpId, },
        ],
        closeAction: async () => {
          await this.onClose();
        },
      };
      await this.$store.dispatch('car/openCarPopup', payload);
    }

    async withoutTrailer() {
      let asyncAction = async () => {
        const action = ITrailer.Action.Make;
        const params: any = {
          command: ITrailer.Command.NoTrailer,
          camId: this.gate.camId,
          movId: this.gate.movId,
        };
        if (this.enterMode) params.corpId = this.corpId;
        let success = await httpResource.httpAction({ action, params });
        if (success) {
          // this.$notify({title: 'Успешно', message: 'Проезд открыт', type: 'success'});
          await this.onClose();
        }
        else {
          // this.$notify({title: 'Ошибка', message: 'Произошла ошибка, попробуйте снова.', type: 'error'});
        }
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    async getTrailers() {
      let asyncAction = async () => {
        const action = ITrailer.Action.Make;
        const params: any = {
          command: ITrailer.Command.Get,
          camId: this.gate.camId,
          carId: this.gate.carId,
        };
        let response = await httpResource.httpAction({ action, params });
        if (response.data.result.trailers) {
          this.trailerList = response.data.result.trailers;
          this.activeTrailer = this.trailerList[0];
        }
        this.dataReady = true;
      };
      let response = await this.$store.dispatch('defaultResourceAction', { asyncAction });
      if (!response.success) {
        await this.onClose();
      }
    }

    async confirmSelectedTrailer(trailer: ITrailer.IEntity, rowIndex: number) {
      this.activeTrailer = trailer;
      let table = document.querySelector('.trailer-popup__table');
      let rows = document.querySelectorAll('.trailer-popup__table .app-table__row');

      if (!rows || !(rows && rows[rowIndex + 1]) || !table) return;

      if (rows[rowIndex + 1].classList.contains('active')) {
        rows[rowIndex + 1].classList.remove('active');
        table.classList.remove('with-active');
        this.activeTrailer = null;
      }
      else {
        table.classList.add('with-active');
        rows[rowIndex + 1].classList.add('active');
        rows.forEach((item, index) => {
          if (rowIndex + 1 !== index) rows[index].classList.remove('active');
        });
      }
    }

    async selectTrailer() {
      let trailer = this.activeTrailer ? this.activeTrailer : this.trailerList[0];
      let asyncAction = async () => {
        const action = ITrailer.Action.Make;
        const params: any = {
          command: ITrailer.Command.Set,
          camId: this.gate.camId,
          carId: this.gate.carId,
          movId: this.gate.movId,
          trailerId: trailer.trailerId,
          trailerMovId: trailer.trailerMovId,
        };
        let success = await httpResource.httpAction({ action, params });
        if (success) {
          // this.$notify({title: 'Успешно', message: 'Счастливого пути', type: 'success'});
          await this.onClose();
        }
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    async confirmCorp() {
      let asyncAction = async () => {
        const action = ITrailer.Action.Make;
        const params: any = {
          command: ITrailer.Command.SetCorp,
          camId: this.gate.camId,
          carId: this.gate.carId,
          movId: this.gate.movId,
          corpId: this.corpId,
        };
        let success = await httpResource.httpAction({ action, params });
        if (success) {
          await this.onClose();
        }
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
